import styled from 'styled-components';

export const PlayerListWrapper = styled.div`
  background-color: var(--BackgroundGrey);
  padding-top: 30px;
  height: 100vh;
`;
